var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed2831;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,83.53V15.47A15.47,15.47,0,0,1,12.45.3a15.31,15.31,0,0,1,3-.3H83.53A15.47,15.47,0,0,1,98.7,12.45a15.31,15.31,0,0,1,.3,3V83.53A15.48,15.48,0,0,1,83.53,99H15.47A15.47,15.47,0,0,1,.3,86.55,15.31,15.31,0,0,1,0,83.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.16,74.59H28.88a1.37,1.37,0,0,1-1.38-1.37V20.93a1.38,1.38,0,0,1,1.38-1.38H56.4v11a4.12,4.12,0,0,0,4.12,4.13h11V73.22A1.37,1.37,0,0,1,70.16,74.59Zm-11-53.1L69.59,31.94H60.52a1.37,1.37,0,0,1-1.37-1.38ZM73.07,31.54,59.55,18a4.15,4.15,0,0,0-2.92-1.21H28.88a4.13,4.13,0,0,0-4.13,4.13V73.22a4.12,4.12,0,0,0,4.13,4.12H70.16a4.11,4.11,0,0,0,4.12-4.12V34.46A4.09,4.09,0,0,0,73.07,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,36.06H46.77a1.38,1.38,0,0,0,0-2.75H33a1.38,1.38,0,1,0,0,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,41.57H33a1.38,1.38,0,1,0,0,2.75H66a1.38,1.38,0,0,0,0-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,49.82H33a1.38,1.38,0,0,0,0,2.76H66a1.38,1.38,0,0,0,0-2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,58.08H33a1.38,1.38,0,1,0,0,2.75H66a1.38,1.38,0,0,0,0-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.16,74.59H28.88a1.37,1.37,0,0,1-1.38-1.37V20.93a1.38,1.38,0,0,1,1.38-1.38H56.4v11a4.12,4.12,0,0,0,4.12,4.13h11V73.22A1.37,1.37,0,0,1,70.16,74.59Zm-11-53.1L69.59,31.94H60.52a1.37,1.37,0,0,1-1.37-1.38ZM73.07,31.54,59.55,18a4.15,4.15,0,0,0-2.92-1.21H28.88a4.13,4.13,0,0,0-4.13,4.13V73.22a4.12,4.12,0,0,0,4.13,4.12H70.16a4.11,4.11,0,0,0,4.12-4.12V34.46A4.09,4.09,0,0,0,73.07,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,36.06H46.77a1.38,1.38,0,0,0,0-2.75H33a1.38,1.38,0,1,0,0,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,41.57H33a1.38,1.38,0,1,0,0,2.75H66a1.38,1.38,0,0,0,0-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,49.82H33a1.38,1.38,0,0,0,0,2.76H66a1.38,1.38,0,0,0,0-2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,58.08H33a1.38,1.38,0,1,0,0,2.75H66a1.38,1.38,0,0,0,0-2.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.94077b7bf40a8b7ac72bfb44c4638656.svg";
export { ForwardRef as ReactComponent };